import DatatablesController from '../../../datatables_controller';

export default class extends DatatablesController {
  initialize(){
    super.initialize();
    this.filter = document.querySelector('[data-controller="admin--index-filter"]');

    if(this.filter){
      this.filterTriggerer = this.filter.querySelector('[data-admin--index-filter-target="filterTriggerer"]');
    }
  }

  connect(){
    super.connect();
    this.bindChangeDateFilter();
    this.bindFilter();
  }

  bindFilter(){
    if(!this.filterTriggerer) return;
    this.filterTriggerer.addEventListener('click', (e) => {
      window.KTApp.blockPage();
      const params = [];

      const inputs = this.filter.querySelectorAll('input,select');
      for(let i=0 ;i<inputs.length; i++){
        if(inputs[i].type === 'radio'){
          if(inputs[i].checked){
            params.push({
              name: inputs[i].name,
              value: inputs[i].value
            });
          }
        } else if(inputs[i].tagName === 'SELECT'){
          if(inputs[i].hasAttribute('multiple')){
            const selectedValues = Array.prototype.slice.call(
              inputs[i].selectedOptions
            ).map((x) => {return x.value});
            params.push({
              name: inputs[i].name,
              value: selectedValues
            });
          } else {
            const selectedOption = inputs[i].selectedOptions[0]
            if(selectedOption){
              params.push({
                name: inputs[i].name,
                value: selectedOption.value
              });
            }
          }
        } else if(inputs[i].type === 'checkbox'){
          if(!inputs[i].checked){
            continue;
          }

          const a = params.filter((x) => {return x.name == inputs[i].name})[0]
          if(a){
            a.value.push(inputs[i].value);
          } else {
            params.push({
              name: inputs[i].name,
              value: [inputs[i].value]
            });
          }

        } else {
          params.push({
            name: inputs[i].name,
            value: inputs[i].value
          });
        }
      }

      if(params.length > 0){
        params.forEach((entry) => {
          this.datatable.setDataSourceParam(entry.name, entry.value);
          this.datatable.load();
        });
      }

      window.KTApp.unblockPage();
      this.filter.click();
    });
  }

  bindChangeDateFilter(){
    $('#kt_dashboard_datepicker_custom').on('change', function(e) {
      this.datatable.setDataSourceParam('date', e.currentTarget.value);
      this.datatable.load();
    }.bind(this));
  }

  datatableColumns(){
    return [
      {
        field: 'index',
        title: 'No',
        sortable: false,
        width: 25,
        type: 'number',
        selector: false,
        textAlign: 'left',
        overflow: 'visible',
        autoHide: false,
        template: function(data) {
          return `<span class="font-weight-bolder">${data.index}</span>`;
        }
      },
      {
        field: 'created_at',
        title: 'Tanggal',
        autoHide: false,
        width: 100,
        template: function(data) {
          return `
            <span data-controller="base--popover" data-base--popover-html="1" data-base--popover-trigger="hover" data-content="Dibuat: ${data.created_at} <br/> Diubah: ${data.updated_at}" data-title="Dibuat/Diubah" class="svg-icon svg-icon-light-dark" style="cursor:pointer;">
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                  <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                      <rect x="0" y="0" width="24" height="24"/>
                      <circle fill="#000000" opacity="0.3" cx="12" cy="12" r="10"/>
                      <rect fill="#000000" x="11" y="10" width="2" height="7" rx="1"/>
                      <rect fill="#000000" x="11" y="7" width="2" height="2" rx="1"/>
                  </g>
              </svg>
            </span>
            <span class="font-weight-bolder">${data.created_at}</span>
            `;
        }
      },
      {
        field: 'group',
        title: 'Tipe',
        overflow: 'visible',
        autoHide: false,
        template: function(data) {
          return `<span class="font-weight-bolder">${data.group}</span>`;
        }
      },
      {
        field: 'price',
        title: 'Nominal',
        overflow: 'visible',
        autoHide: false,
        template: function(data) {
          return `<span class="font-weight-bolder">${data.price}</span>`;
        }
      },
      {
        field: 'payment_object',
        title: 'Object',
        sortable: false,
        overflow: 'visible',
        autoHide: false,
        template: function(data) {
          let status = '';
          if (data.payment.status) {
            status = `<div><b>Status</b>: ${data.payment.status}</div>`;
          }
          let contents = `
          <div>
            ${status}
            <div><b>No. Referensi</b>: ${data.payment.number}</div>
            <div><b>Ref. User</b>: ${data.payment.user_name}</div>
            <div><b>Desc</b>: ${data.payment.desc}</div>
          </div>
          `.trim();

          return `
            <span
              data-controller="base--popover"
              data-base--popover-html="1"
              data-base--popover-trigger="click"
              data-content="${contents}"
              data-title="Detail"
              class="svg-icon svg-icon-light-dark" style="cursor:pointer;"
            >
              <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                  <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                      <rect x="0" y="0" width="24" height="24"/>
                      <circle fill="#000000" opacity="0.3" cx="12" cy="12" r="10"/>
                      <rect fill="#000000" x="11" y="10" width="2" height="7" rx="1"/>
                      <rect fill="#000000" x="11" y="7" width="2" height="2" rx="1"/>
                  </g>
              </svg>
            </span>
            <span class="font-weight-bolder">${data.payment.object}</span>
          `;
        }
      },
    ]
  }
}
